import "./App.css";
import "../src/Assets/Css/style.css";
import "primereact/resources/primereact.min.css";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import AgencyInformation from "./Questionnaire/AgencyInformation";
import ScalePage from "./Questionnaire/ScalePage";
import QuestionList from "./Questionnaire/QuestionList";
import Login from "./Account/Login";
import Summary from "./Questionnaire/Summary";
import Simulator from "./Simulator/Simulator";
import HistoryLandingPage from "./History/HistoryLandingPage";
import ValidateToken from "./Account/ValidateToken";
import Register from "./Account/Register";
import NotFound from "./Common/NotFound";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Login />}></Route>
        <Route path="/validate" element={<ValidateToken />}></Route>
        <Route path="/agencyinfo" element={<AgencyInformation />}></Route>
        <Route path="/scale" element={<ScalePage />}></Route>
        <Route path="/question" element={<QuestionList />}></Route>
        <Route path="/summary" element={<Summary />}></Route>
        <Route path="/simulator" element={<Simulator />}></Route>
        <Route path="/history" element={<HistoryLandingPage />}></Route>
  <Route path="/newuser" element={<Register />}></Route>
  <Route path="*" element={<NotFound />}></Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
